import { useGetBuckets } from "@entities/bucket/lib/hooks/useGetBuckets";
import { Select } from "antd";
import { useState } from "react";
import SelectInput from "../SelectInput";
const { Option } = Select;

const AddToBucket = ({
  bucketIds,
  setselectedbuckedIds,
  mode
}: {
  bucketIds: string[];
  setselectedbuckedIds: (ids: string[]) => void;
  mode?: "multiple" | "tags"
}) => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  const [searchQuery, setSearchQuery] = useState<string>("");
  const { buckets, isFetching } = useGetBuckets({
    pageNo: 1,
    limit: 100,
    searchQuery,
  });

  return (
    <>
      <SelectInput
        placeholder="Choose buckets"
        value={bucketIds}
        onchange={(val) => setselectedbuckedIds(typeof(val) === "string" ? [val] : val)}
        options={
          buckets?.map((bucket) => ({
            label: bucket.name,
            value: bucket.bucketId,
          })) || []
        }
        onSearch={(query) => setSearchQuery(query)}
        dropdownOpen={dropdownOpen}
        setDropdownOpen={setDropdownOpen}
        isFetching={isFetching}
        allowClear
        mode={mode}
        showSearch
      />
    </>
  );
};

export default AddToBucket;
